export type DeckPageRoute =
  | Readonly<{ kind: 'library' }>
  | Readonly<{ kind: 'editor'; deckId: string }>;

const DECK_DETAIL_PATH = /^\/decks\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/u;

/** Exact browser routes only: private deck ids never participate in a catch-all fallback. */
export function parseDeckPageRoute(pathname: string): DeckPageRoute | undefined {
  if (pathname === '/decks') return { kind: 'library' };
  const match = DECK_DETAIL_PATH.exec(pathname);
  return match?.[1] === undefined ? undefined : { kind: 'editor', deckId: match[1] };
}
